import type { IconName } from '@deskworks/view-runtime';
import {
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Bell,
  Book,
  Bot,
  Box,
  Calendar,
  ChartColumn,
  Check,
  ChevronDown,
  ChevronRight,
  CircleAlert,
  CircleCheck,
  Clock,
  DollarSign,
  Download,
  Ellipsis,
  Euro,
  ExternalLink,
  Eye,
  File,
  Flag,
  Folder,
  Funnel,
  Globe,
  Heart,
  House,
  Image,
  Info,
  Link,
  List,
  Lock,
  LockOpen,
  Mail,
  MessageSquare,
  Minus,
  Pause,
  Pencil,
  Phone,
  Play,
  Plus,
  RefreshCw,
  Rocket,
  Search,
  Send,
  Settings,
  ShoppingCart,
  Sparkles,
  Square,
  SquareKanban,
  Star,
  Tag,
  ThumbsDown,
  ThumbsUp,
  Trash,
  TriangleAlert,
  Truck,
  Upload,
  User,
  Users,
  X,
  Zap,
  type LucideIcon,
} from 'lucide-react';

/** The view kit's icon names (kit.ts ICONS) → Deskworks's icons. */
export const ICON_MAP: Record<IconName, LucideIcon> = {
  check: Check,
  x: X,
  plus: Plus,
  minus: Minus,
  edit: Pencil,
  trash: Trash,
  send: Send,
  search: Search,
  filter: Funnel,
  refresh: RefreshCw,
  download: Download,
  upload: Upload,
  link: Link,
  external: ExternalLink,
  eye: Eye,
  clock: Clock,
  calendar: Calendar,
  user: User,
  users: Users,
  mail: Mail,
  message: MessageSquare,
  bell: Bell,
  star: Star,
  heart: Heart,
  flag: Flag,
  tag: Tag,
  file: File,
  folder: Folder,
  image: Image,
  chart: ChartColumn,
  list: List,
  board: SquareKanban,
  settings: Settings,
  info: Info,
  warning: TriangleAlert,
  alert: CircleAlert,
  success: CircleCheck,
  lock: Lock,
  unlock: LockOpen,
  play: Play,
  pause: Pause,
  stop: Square,
  'arrow-right': ArrowRight,
  'arrow-left': ArrowLeft,
  'arrow-up': ArrowUp,
  'arrow-down': ArrowDown,
  'chevron-right': ChevronRight,
  'chevron-down': ChevronDown,
  more: Ellipsis,
  sparkles: Sparkles,
  rocket: Rocket,
  'thumbs-up': ThumbsUp,
  'thumbs-down': ThumbsDown,
  globe: Globe,
  euro: Euro,
  dollar: DollarSign,
  cart: ShoppingCart,
  box: Box,
  truck: Truck,
  phone: Phone,
  home: House,
  book: Book,
  bot: Bot,
  zap: Zap,
};
